import './ModalVideo.scss';

import $ from "jquery";

export default class ModalVideo {

    init() {
        $(".video-play").click(function () {
            let theModal = $(this).data("target");
            let videoSRC = $(this).attr("data-video");
            let videoSRCauto = videoSRC + "&showinfo=0&html5=1&autoplay=1";

            $(theModal + ' iframe').attr('src', videoSRCauto);

            $(theModal).on("hidden.bs.modal", () => {
                $(theModal + ' iframe').attr('src', "");
            });
        });
    }

}



// WEBPACK FOOTER //
// ./Src/Shared/ModalVideo/ModalVideo.js